module.exports = __webpack_public_path__ + "static/img/mb-12.d36c7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w10/mb-12.jpg
// module id = AvUk
// module chunks = 1